import { Link, useParams } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryTabs() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
            slug === cat.slug
              ? "bg-primary-500 text-background-950"
              : "bg-background-800 text-foreground-400 hover:text-foreground-200 hover:bg-background-700"
          }`}
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className={`${cat.icon} text-xs`}></i>
          </span>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}